import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-btn-back',
  standalone: false,
  templateUrl: './btn-back.component.html',
  styleUrl: './btn-back.component.scss',
})
export class BtnBackComponent {
  mostrar = true;

  constructor(private location: Location, private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.mostrar = event.urlAfterRedirects !== '/menu';
      });
  }

  volver(): void {
    this.location.back();
  }
}
